export default ({
  GET_SYSTEM_INFO_REQUEST: "GET_SYSTEM_INFO_REQUEST",
  GET_SYSTEM_INFO_SUCCESS: "GET_SYSTEM_INFO_SUCCESS",
  GET_SYSTEM_INFO_FAILURE: "GET_SYSTEM_INFO_FAILURE",
  SET_SYSTEM_INFO_REQUEST: "SET_SYSTEM_INFO_REQUEST",
  SET_SYSTEM_INFO_SUCCESS: "SET_SYSTEM_INFO_SUCCESS",
  SET_SYSTEM_INFO_FAILURE: "SET_SYSTEM_INFO_FAILURE",
});